import { Table } from 'react-bootstrap';
import { ReactNode } from 'react';

export type TableColumn<T> = {
    id: string;
    name: string;
    data: string | null;
    default?: string;
    render?: (data: any, index: number, row: T) => ReactNode
}

type Props = {
    id: string;
    columns: TableColumn<any>[];
    columnsMobile?: TableColumn<any>[];
    data: {[key: string]: any}[];
    emptyDataText?: string;
};

export default function customTable(props: Props) {
    // const customDom = "<'d-flex justify-content-between align-items-center my-3'Bf>t<'d-flex justify-content-between align-items-center m-2'lip>";
    const {id, columns, columnsMobile, data, emptyDataText} = props;

    return (
        <Table id={id} striped bordered hover>
            <thead className="thead-desktop">
                <tr>
                    {columns.map((column: TableColumn<any>, index: number) => {
                        return <th
                            id={`${id}_${column.id}`}
                            key={index}
                            data-index={index}
                            className={'th-desktop'}
                        >
                            {column.name}
                        </th>
                    })}
                </tr>
            </thead>
            <thead className="thead-mobile">
                <tr>
                    {columnsMobile && columnsMobile.length ? columnsMobile.map(
                        (column: TableColumn<any>, index: number) => {
                            return <th
                                id={`${id}_${column.id}`}
                                key={index}
                                data-index={index}
                                className={'th-mobile'}
                            >
                                {column.name}
                            </th>
                        }
                    ) : <></>}
                </tr>
            </thead>
            <tbody className='tbody-desktop'>
                {data.length ? data.map((element: {[key: string]: any}, index: number) => {
                    return <tr key={index} className='tr-desktop'>{getTableBody(props, element, 'desktop')}</tr>
                }) : <tr>
                    <td colSpan={columns.length} className="text-center">
                        {emptyDataText ? emptyDataText : 'Nessuna informazione da mostrare in questa tabella'}
                    </td>
                </tr>}
            </tbody>
            <tbody className='tbody-mobile'>
                {data.length ? data.map((element: {[key: string]: any}, index: number) => {
                    return <tr key={index} className='tr-mobile'>
                        {columnsMobile && columnsMobile.length ? columnsMobile.map(
                            (column: TableColumn<any>, index2: number) => {
                                let columnId     = `${id}_${column.id}_${index2}`;
                                let defaultValue = column.default !== undefined        ? column.default       : "-";
                                let columnValue  = column.data && element[column.data] ? element[column.data] : defaultValue;
                                // console.log('mobile col value:', columnValue);

                                return <td
                                    id={columnId}
                                    key={index2}
                                    data-index={index2}
                                    className={'td-mobile'}
                                >
                                    {typeof column.render !== 'undefined'
                                    ? column.render(columnValue, index2, element)
                                    : String(columnValue)
                                }
                                </td>;
                            }
                        ) : getTableBody(props, element, 'mobile')}
                    </tr>
                }) : <tr>
                    <td colSpan={columns.length} className="text-center">
                        {emptyDataText ? emptyDataText : 'Nessuna informazione da mostrare in questa tabella'}
                    </td>
                </tr>}
            </tbody>
        </Table>
    )
}

function getTableBody(props: Props, element: any, type: 'desktop' | 'mobile') {
    const {id, columns} = props;
    
    return columns.map((column: TableColumn<any>, index2: number) => {
        let columnId     = `${id}_${column.id}_${index2}`;
        let defaultValue = column.default        !== undefined ? column.default       : "-";
        let columnValue  = column.data && element[column.data] ? element[column.data] : defaultValue;

        return <td
            id={columnId}
            key={index2}
            data-index={index2}
            className={'td-' + type}
        >
            {typeof column.render !== 'undefined'
                ? column.render(columnValue, index2, element)
                : String(columnValue)
            }
        </td>;
    })
}